<template>
    <div class="grocery-page-template-module">
        <product-page
            :breadcrumbs="breadcrumbs"
            :product="productData"
            :related="relatedRecipes"
            :categories="attributes.asyncData.categories"
            :read-more-title="attributes.read_more_title"
            :read-more-content="attributes.read_more_content"
            type="grocery"
        />

        <page-module-builder
            :components="templateComponents"
        />
    </div>
</template>

<script>
    import PageModuleBuilder from '../../PageModuleBuilder/PageModuleBuilder';
    import ProductPage from '../../../organisms/ProductPage/ProductPage';
    import { formatBreadcrumbsForProductPage, formatDataForGroceryProductPage } from '../../../../lib/grocery-product';
    import { formatRecipesForCards } from '../../../../lib/recipes';

    export default {
        name: 'grocery-page-template-module',

        components: { ProductPage, PageModuleBuilder },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ store, route }) {
            const locale = store.state.locales.locales.find(({ code }) => code === route.path.split('/')[1] ?? 'en')?.code ?? 'en';

            const categories = await store.dispatch('grocery/fetchCategories', {
                locale,
            });

            return {
                categories,
            };
        },

        computed: {
            /**
             * Convert the attributes to components.
             *
             * @returns {Array}
             */
            templateComponents() {
                return Object.entries(this.attributes)
                    .filter(([, val]) => typeof val === 'object' && val?.__typename)
                    .reduce((components, [, val]) => ([
                        ...components,
                        {
                            __page: this.attributes.__page,
                            ...val,
                        },
                    ]), []);
            },

            /**
             * Return the product data to pass to the grocery page.
             *
             * @returns {object}
             */
            productData() {
                return formatDataForGroceryProductPage(this, this.attributes);
            },

            /**
             * Generate breadcrumbs.
             *
             * @returns {Array}
             */
            breadcrumbs() {
                return formatBreadcrumbsForProductPage(this, this.attributes);
            },

            /**
             * Return the recipes for the "related recipes" section.
             *
             * @returns {{title: string, items: {image: {src: string, alt: string}, note: string, name: string, description: string, to: string}[]}}
             */
            relatedRecipes() {
                const product = this.attributes.grocery_product;
                const recipes = product
                    ?.related_recipes;

                return {
                    title: `${ product?.marketing_title } ${ this.$snippet('recipes', 'recipes') }`,
                    items: formatRecipesForCards(this, recipes),
                };
            },
        },
    };
</script>
